import styles from "./AscModalDelete.module.scss";
import AscModal from "../AscModal/AscModal";
import AscButton from "../AscButton/AscButton";

export interface AscModalDeleteProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  title?: string;
  onCancel?: () => void;
  onApprove: () => void;
}

export default function AscModalDelete({
  visible,
  setVisible,
  title = "Are you sure you want to delete the student?",
  onCancel,
  onApprove,
}: AscModalDeleteProps) {
  return (
    <AscModal
      visible={visible}
      setVisible={setVisible}
      modalClassName={styles.modalClassName}
      backdropClassName={styles.backdropClassName}
      hasCloseBtn={false}
    >
      <div className={styles.content}>
        <span className={styles.contentTitle}>{title}</span>
        <div className={styles.contentFooter}>
          <AscButton
            type="button"
            variant="gray"
            onClick={() => {
              onCancel?.();
              setVisible(false);
            }}
          >
            Cancel
          </AscButton>
          <AscButton type="button" variant="red" onClick={onApprove}>
            Delete
          </AscButton>
        </div>
      </div>
    </AscModal>
  );
}
